import { Box, Button, Card, Grid, Paper } from "@mui/material";
import { useState, useEffect, useMemo } from 'react';
import { styled } from "@mui/material/styles";
import SetupTimes from "./SetupTimes";
import IdleTimes from "./IdleTimes";
import ClosejobOperationbutton from "./ClosejobOperationbutton";
import ProductionStart from "./ProductionStart";
import { useLocation, useNavigate } from "react-router-dom";
import ViewJobPlan from "./ViewJobPlan";




import setupgif from './Images/setupgif.gif';
import setuppng from './Images/setuppng.png';
import idlegif from './Images/idlegif.gif';
import idlepng from './Images/idlepng.gif';
import ShiftRemarksButton from "./shiftRemarksButton";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function JobOperation() {

  const location = useLocation();
  const navigate = useNavigate();
  const state = useMemo(() => location.state || {}, [location.state]);

  // Retrieve values from location state or session storage
  const username = state.username || sessionStorage.getItem('username');
  const operation_code = state.operation_code || sessionStorage.getItem('operation_code');
  const operation_description = state.operation_description || sessionStorage.getItem('operation_description');
  const start_datetime = state.start_datetime || sessionStorage.getItem('start_datetime');
  const employee_id = state.employee_id || sessionStorage.getItem('employee_id');
  const machine_code = state.machine_code || state.machineCode || sessionStorage.getItem('machine_code');

  const jobNumber = state.jobNumber || sessionStorage.getItem('jobNumber');
  const customer = state.customer || sessionStorage.getItem('customer');
  const operation = state.operation || sessionStorage.getItem('operation');
  const product = state.product || sessionStorage.getItem('product');
  const startedTime = state.startedTime || sessionStorage.getItem('startedTime');
  const plannedQty = state.plannedQty || sessionStorage.getItem('plannedQty');
  const OperationalTime = state.OperationalTime || sessionStorage.getItem('OperationalTime');
  const SetupAndOpeTime = state.SetupAndOpeTime || sessionStorage.getItem('SetupAndOpeTime');
  const SetupTime = state.SetupTime || sessionStorage.getItem('SetupTime');
  const operation_type = state.operation_type || sessionStorage.getItem('operation_type');

  const [selectedButton, setSelectedButton] = useState(null);
  const [initialLoad, setInitialLoad] = useState(true);


  useEffect(() => {
    if (state.username) sessionStorage.setItem('username', state.username);
    if (state.operation_code) sessionStorage.setItem('operation_code', state.operation_code);
    if (state.operation_description) sessionStorage.setItem('operation_description', state.operation_description);
    if (state.start_datetime) sessionStorage.setItem('start_datetime', state.start_datetime);
    if (state.employee_id) sessionStorage.setItem('employee_id', state.employee_id);
    if (state.machine_code) sessionStorage.setItem('machine_code', state.machine_code);
    if (state.reason) sessionStorage.setItem('reason', state.reason);
    if (state.jobNumber) sessionStorage.setItem('jobNumber', state.jobNumber);
    if (state.customer) sessionStorage.setItem('customer', state.customer);
    if (state.operation) sessionStorage.setItem('operation', state.operation);
    if (state.product) sessionStorage.setItem('product', state.product);
    if (state.startedTime) sessionStorage.setItem('startedTime', state.startedTime);
    if (state.plannedQty) sessionStorage.setItem('plannedQty', state.plannedQty);
    if (state.OperationalTime) sessionStorage.setItem('OperationalTime', state.OperationalTime);
    if (state.SetupAndOpeTime) sessionStorage.setItem('SetupAndOpeTime', state.SetupAndOpeTime);
    if (state.SetupTime) sessionStorage.setItem('SetupTime', state.SetupTime);
    if (state.operation_type) sessionStorage.setItem('operation_type', state.operation_type);
  }, [state]);



  const formattedStartedTime = startedTime
    ? (() => {
      const startTime = new Date(startedTime);
      startTime.setHours(startTime.getHours() + 5); // Adding 5 hours
      startTime.setMinutes(startTime.getMinutes() + 30); // Adding 30 minutes

      const options = {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        // second: "numeric",
        hour12: true,
      };

      // Format the date
      const formattedDate = startTime.toLocaleString("en-US", options);

      // Replace " at " with "-"
      return formattedDate.replace(" at ", "-");
    })()
    : "";



  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName === selectedButton ? null : buttonName);
  };


  useEffect(() => {
  console.log("Received state in /JobOperation:", state);
}, [state]);


  useEffect(() => {

    if (initialLoad) {
      if (operation_type === 'Setup') {
        setSelectedButton('button1');
      } else if (operation_type === 'Idle') {
        setSelectedButton('button2');
      }
      setInitialLoad(false); // Setting the initial load to false after the first run
    }
  }, [initialLoad, operation_type]);

  useEffect(() => {
    const handlePopState = (event) => {
      window.history.pushState(null, document.title, window.location.href);
      alert("You can't go back from this window-කණගාටුයි! ඔබට මෙම පේජ් එකෙන් පසුපසට යා නොහැක.");
    };

    window.addEventListener('popstate', handlePopState);
    window.history.pushState(null, document.title, window.location.href);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);


  return (
    <div >
      <Card
        sx={{
          maxWidth: 1000,
          margin: "auto",
          padding: 0.5,
          paddingTop: 0,
          backgroundColor: 'rgba(185, 190, 221, 0.5)',
          backdropFilter: 'blur(5px)',
          // border: '1.5px solid white',
        }}
        display="flex"

      >

        <Grid container item spacing={0.2}>
          <Grid item xs={4} sx={{ boxShadow: "none" }}>

              <ShiftRemarksButton Employee_ID={username} />

          </Grid>
          <Grid item xs={4} sx={{ boxShadow: "none" }}>
            <Item sx={{ backgroundColor: "purple", marginTop: "3px", border: '1.5px solid white', }}>
              <h3 style={{ margin: "0px", color: "white" }}>JOB OPERATION</h3>
            </Item>
          </Grid>
          <Grid item xs={4} sx={{ boxShadow: "none" }}>
           
              <ViewJobPlan username={username} />

          </Grid>
        </Grid>


        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={0.5}>
            <Grid container item spacing={0.5} >
              <Grid item xs={1.5} >
                <Item sx={{ backgroundColor: "#ffe500", textAlign: "right", color: "black", padding: "3px" }}>
                  <b>JOB NUMBER:</b>
                </Item>
              </Grid>
              <Grid item xs={4.5} >
                <Item sx={{ backgroundColor: "white", textAlign: "left", color: "black", padding: "3px" }}>
                  <b>{jobNumber}</b>
                </Item>
              </Grid>
              <Grid item xs={0.25}></Grid>
              <Grid item xs={1.75}>
                <Item sx={{ backgroundColor: "#ffe500", color: "black", padding: "3px" }}>
                  <b>Planned Qty</b>
                </Item>
              </Grid>
              <Grid item xs={4}>
                <Item sx={{ backgroundColor: "white", color: "black", padding: "3px" }}>
                  <b>{plannedQty}</b>
                </Item>
              </Grid>
            </Grid>
            <Grid container item spacing={0.5}>
              <Grid item xs={1.5}>
                <Item sx={{ backgroundColor: "#ffe500", textAlign: "right", color: "black", padding: "3px" }}>
                  <b>CUSTOMER:</b>
                </Item>
              </Grid>
              <Grid item xs={4.5}>
                <Item sx={{ backgroundColor: "white", textAlign: "left", color: "black", padding: "3px" }}>
                  <b>{customer}</b>
                </Item>
              </Grid>
              <Grid item xs={0.25}></Grid>
              <Grid item xs={1.75}>
                <Item sx={{ backgroundColor: "#ffe500", color: "black", padding: "3px" }}>
                  <b>Total Plan Time:</b>
                </Item>
              </Grid>
              <Grid item xs={2}>
                <Item sx={{ backgroundColor: "#ffe500", color: "black", padding: "3px" }}>
                  <b>Setup time</b>
                </Item>
              </Grid>
              <Grid item xs={2}>
                <Item sx={{ backgroundColor: "#ffe500", color: "black", padding: "3px" }}>
                  <b>Operational Time</b>
                </Item>
              </Grid>
            </Grid>
            <Grid container item spacing={0.5}>
              <Grid item xs={1.5}>
                <Item sx={{ backgroundColor: "#ffe500", textAlign: "right", color: "black", padding: "3px" }}>
                  <b>PRODUCT:</b>
                </Item>
              </Grid>
              <Grid item xs={4.5}>
                <Item sx={{ backgroundColor: "white", textAlign: "left", color: "black", padding: "3px" }}>
                  <b>{product}</b>
                </Item>
              </Grid>
              <Grid item xs={0.25}></Grid>
              <Grid item xs={1.75}>
                <Item sx={{ backgroundColor: "#fffaca", padding: "3px" }}>
                  <b>{SetupAndOpeTime}</b>{" "}
                </Item>
              </Grid>
              <Grid item xs={2}>
                <Item sx={{ backgroundColor: "#fffaca", padding: "3px" }}>
                  <b>{SetupTime}</b>
                </Item>
              </Grid>
              <Grid item xs={2}>
                <Item sx={{ backgroundColor: "#fffaca", padding: "3px" }}>
                  <b>{OperationalTime}</b>
                </Item>
              </Grid>
            </Grid>
            <Grid container item spacing={0.5}>
              <Grid item xs={1.5}>
                <Item sx={{ backgroundColor: "#ffe500", textAlign: "right", color: "black", padding: "3px" }}>
                  <b>OPERATION:</b>
                </Item>
              </Grid>
              <Grid item xs={4.5}>
                <Item sx={{ backgroundColor: "white", textAlign: "left", color: "black", padding: "3px" }}>
                  <b>{operation}</b>
                </Item>
              </Grid>
              <Grid item xs={0.25}></Grid>
              <Grid item xs={3.25}>
                <Item sx={{ backgroundColor: "skyblue", color: "black", padding: "3px", border: '1.5px solid white', }}>
                  <b>St.Time:{formattedStartedTime}</b>
                </Item>
              </Grid>
              <Grid item xs={0.05}></Grid>
              <Grid item xs={1.7}>
                <ClosejobOperationbutton
                  startedTime={startedTime}
                  jobNumber={jobNumber}
                  product={product}
                  username={username}
                  customer={customer}
                  operation={operation}
                  start_datetime={start_datetime}
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Card>
      <Card
        sx={{
          maxWidth: 1000,
          margin: "auto",
          marginTop: 0.4,
          padding: "8px",

        }}
        display="flex"

      >
        <Box sx={{ flexGrow: 1, backgroundColor: 'transparent' }}>
          <Grid container spacing={0.5} sx={{ backgroundColor: 'transparent' }}>
            <Grid item xs={1}>
              
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant={selectedButton === "button1" ? "contained" : "outlined"}
                    color="primary"
                    onClick={() => handleButtonClick("button1")}
                    style={{
                      width: "70px",
                      height: "132px",
                      marginBottom: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    }}
                    sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}
                  >
                    <img
                      src={selectedButton === "button1" ? setupgif : setuppng}
                      alt="Setup Time"
                      style={{ width: "60px", marginBottom: "5px" }}
                    />
                    <span>Setup Time</span>
                  </Button>

                  <Button
                    variant={
                      selectedButton === "button2" ? "contained" : "outlined"
                    }
                    color="primary"
                    onClick={() => handleButtonClick("button2")}
                    style={{ width: "70px", height: "132px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}
                    sx={{ display: "flex", flexDirection: "column-reverse" }}
                  >
                    <img
                      src={selectedButton === "button2" ? idlegif : idlepng}
                      alt="Idle Time"
                      style={{ width: "60px", marginBottom: "5px" }}
                    />
                    <span>Idle Time</span>

                  </Button>
                </div>
              
            </Grid>
            <Grid item xs={11} sx={{maxHeight:"45vh" , margin:"auto"}} >
              {selectedButton === "button1" && (
                
                  <SetupTimes
                    startedTime={startedTime}
                    username={username}
                    jobNumber={jobNumber}
                    customer={customer}
                    operation={operation}
                    product={product}
                    operation_code={operation_code}
                    operation_description={operation_description}
                    start_datetime={start_datetime}
                    employee_id={employee_id}
                    machine_code={machine_code}
                    OperationalTime={OperationalTime}


                  />
                
              )}
              {selectedButton === "button2" && (

                  <IdleTimes
                    startedTime={startedTime}
                    username={username}
                    jobNumber={jobNumber}
                    customer={customer}
                    operation={operation}
                    product={product}
                    operation_code={operation_code}
                    operation_description={operation_description}
                    start_datetime={start_datetime}
                    employee_id={employee_id}
                    machine_code={machine_code}
                    OperationalTime={OperationalTime}

                  />
              )}
            </Grid>
          </Grid>
          <ProductionStart
            start_datetime={start_datetime}
            username={username}
            jobNumber={jobNumber}
            customer={customer}
            operation={operation}
            product={product}
            machine_code={machine_code}
            startedTime={startedTime}
          />
        </Box>
      </Card>
    </div>
  );
}




